import { simulatorAxiosInstance } from 'api/config'

export const getSimulation = (body) => {
  return simulatorAxiosInstance.post('api/simulateCredit/', body)
}

export { simulatorAxiosInstance }
